import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  color: ${props => props.theme.validation.color};
  font-size: ${props => props.theme.validation.fontSize};
  margin-top: ${props => props.noMargin ? 'inherit' : (props.theme.validation.marginTop || '5px')};
  * {
    color: ${props => props.theme.validation.color};
  }
`;

Container.defaultProps = {
  theme: {
    validation: {
      fontSize: '16px',
      color: '#e8141e'
    }
  }
};

const Message = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.largeValidationGap
    ? (props.theme.validation.largeIconGap || '10px')
    : (props.theme.validation.iconGap || '4px')};
`;

Message.defaultProps = {theme: {validation: {}}};

const Icon = styled.span`
  display: ${props => props.theme.validation.icon ? 'inline-block' : 'none'};
  flex: none;
  margin-left: ${props => props.largeValidationGap && (props.theme.validation.largeGapMarginLeft || '2px')};
  width: ${props => props.theme.validation.iconWidth || '16px'};
  height: ${props => props.theme.validation.iconHeight || '16px'};
  background-image: ${props => props.theme.validation.icon ? `url(${props.theme.validation.icon})` : 'none'};
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
`;

Icon.defaultProps = {theme: {validation: {}}};

const renderMessage = (e, largeValidationGap) => (
  <Message key={e} largeValidationGap={largeValidationGap}><Icon aria-hidden='true' largeValidationGap={largeValidationGap} />{e}</Message>
);

export default class Validation extends Component {
  static propTypes = {
    infos: PropTypes.array,
    warnings: PropTypes.array,
    errors: PropTypes.array,
    noMargin: PropTypes.bool
  };

  render() {
    const {errors, warnings, infos, largeValidationGap} = this.props;

    if (this.props.noMargin === true) {
      return <>
        {errors && errors.map(e => <Container noMargin={this.props.noMargin} key={e}>{renderMessage(e, largeValidationGap)}</Container>)}
        {warnings && warnings.map(e => <Container noMargin={this.props.noMargin} key={e}>{renderMessage(e, largeValidationGap)}</Container>)}
        {infos && infos.map(e => <Container noMargin={this.props.noMargin} key={e}>{renderMessage(e, largeValidationGap)}</Container>)}
      </>;
    }
    return <Container>
      {errors && errors.map(e => renderMessage(e, largeValidationGap))}
      {warnings && warnings.map(e => renderMessage(e, largeValidationGap))}
      {infos && infos.map(e => renderMessage(e, largeValidationGap))}
    </Container>
  }
}
